import React, { useContext, useEffect, useState } from 'react';
import './ProfileBox.css';
import { Account } from '../account';
import {
  getImageUrl,
  GLOBAL_COLORS, handleImageError,
  useGetGravatarOrUploadedProfileImg,
} from '../../hooks';
import { AppDataContext } from '../../utils';
import { IBLSpinLoader } from '../IBLSpinLoader';
import { FaShareAlt, FaFacebookF } from 'react-icons/fa';
import { FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';
import { LuPencil } from 'react-icons/lu';
import accountImg from '../../assets/images/ibl-user-account.png'

import { Avatar, Typography, Stack } from '@mui/material';

function stringAvatar(name) {
  const parts = name.trim().split(' ');
  const firstInitial = parts[0]?.[0] || '';
  const lastInitial = parts.length > 1 ? parts[parts.length - 1]?.[0] : '';
  const initials = (firstInitial + lastInitial).toUpperCase();

  return {
    children: initials,
  };
}

const ProfileBox = () => {
  const { appData } = useContext(AppDataContext);
  const [isFocused, setIsFocused] = React.useState(false);
  const [facebookUrl, setFacebookUrl] = useState('');
  const [linkedinUrl, setLinkedinUrl] = useState('');
  const [twitterUrl, setTwitterUrl] = useState('');
  const [socialEnabled, setSocialEnabled] = useState(true);

  const { profilePic } = useGetGravatarOrUploadedProfileImg(
    appData.userMetaData
  );

  const handleProfileBoxClick = () => {
    setIsFocused(!isFocused);
  };

  const socialMediaIconsList = [
    { url: facebookUrl, Icon: FaFacebookF },
    { url: linkedinUrl, Icon: FaLinkedinIn },
    { url: twitterUrl, Icon: FaXTwitter },
  ]
  const populateSocialMediaLinks = () => {
    const socialLinks = appData.userMetaData?.social_links;
    if (Array.isArray(socialLinks) && socialLinks?.length > 0) {
      socialLinks.forEach(function (socialLink) {
        if (
          !socialLink?.social_link ||
          socialLink?.social_link === '' ||
          socialLink?.social_link === '#'
        ) {
          return;
        }
        const platform = socialLink?.platform;

        if (platform === 'linkedin') {
          setLinkedinUrl('https://linkedin.com/in/' + socialLink?.social_link);
        }
        if (platform === 'twitter') {
          setTwitterUrl('https://twitter.com/' + socialLink?.social_link);
        }

        if (platform === 'facebook') {
          setFacebookUrl('https://www.facebook.com/' + socialLink?.social_link);
        }
      });
    } else {
      setSocialEnabled(false);
    }
  };

  useEffect(() => {
    appData.userMetaDataLoaded && populateSocialMediaLinks();
  }, [appData.userMetaDataLoaded]);
 
  return (
    <>
      <div className="prof_box pp pad_18">
        {appData.userMetaDataLoaded ? (
          <>
            <div className="div-block-8 m_b_0">
              {appData?.userMetaData?.profile_image?.has_image ? <img alt="" className="image-7" loading="lazy" src={profilePic}
                onError={e => handleImageError(e, accountImg)}
              />
                :
                <Avatar className="image-7" sx={{ bgcolor: '#528AC0', width: 110, height: 110, fontSize: 32, fontFamily: 'Lexend' }} {...stringAvatar(appData?.userMetaData?.name)} />
              }
              <div className="w-layout-vflex flex-block-20 flex_gap">
                <div
                  onClick={() => handleProfileBoxClick()}
                  className="div-block-3"
                >
                  <div className="text-block wrapContent">{appData.userMetaData?.name}</div>
                </div>
                <div className='wrapContentTitle'>{appData.userMetaData?.bio}</div>
                {socialEnabled && (
                  <div className="custom-left">
                    {socialMediaIconsList
                      .filter(({ url }) => url && url !== '#')
                      .map(({ url, Icon }, index) => (
                        <a
                          key={index}
                          className={"profile-pox-socials-link w-inline-block"}
                          href={url}
                        >
                          <Icon
                            className={"profile-pox-socials-link-icon"}
                            color={GLOBAL_COLORS.icon_color}
                          />
                        </a>
                      ))}
                  </div>
                )}
              </div>
            </div>
            {/*TODO : the share button is not working*/}
            <div className="div-block-161 edit_profile_trigger home tl_m">
              <a className="w-inline-block">
                <LuPencil
                  color={GLOBAL_COLORS.icon_color}
                  className={'image-24 home'}
                  onClick={() => handleProfileBoxClick()}
                />
                <img
                  alt=""
                  className="ph"
                  loading="lazy"
                  sizes="100vw"
                  src="images/62a1d40ebd16fee404a1d732_pencil.png"
                  srcSet="images/62a1d40ebd16fee404a1d732_pencil-p-500.png 500w, images/62a1d40ebd16fee404a1d732_pencil.png 512w"
                />
              </a>
            </div>

          </>
        ) : (
          <IBLSpinLoader size={40} containerHeight={'100px'} />
        )}
      </div>
      {appData.userMetaDataLoaded && isFocused && (
        <Account onModalClose={() => setIsFocused(false)} />
      )}
    </>
  );
};

export { ProfileBox };
